document.addEventListener('DOMContentLoaded', () => {

// FingerprintJS - 使用 CDN
const fpScript = document.createElement('script');
fpScript.src = 'https://cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@4/dist/fp.min.js';
document.head.appendChild(fpScript);

let myFingerprint = null;   // browser-level (FingerprintJS)
let myDeviceId = null;      // device-level (硬體特徵)
let myDisplayCode = null;
let currentLottery = null;
let registered = false;
let resultShown = false;

// 收集跨瀏覽器一致的裝置硬體特徵
function collectDeviceSignals() {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    let gpu = '';
    if (gl) {
        const dbg = gl.getExtension('WEBGL_debug_renderer_info');
        if (dbg) {
            gpu = gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) || '';
        }
    }

    return {
        screen: `${screen.width}x${screen.height}`,
        dpr: window.devicePixelRatio || 1,
        cores: navigator.hardwareConcurrency || 0,
        memory: navigator.deviceMemory || 0,
        platform: navigator.platform || '',
        gpu: gpu,
        touchPoints: navigator.maxTouchPoints || 0,
    };
}

// 填充進度相關
const CLICKS_TO_FILL = 25;
let clickCount = 0;
let fillAnimating = false;

const heartDisplay = document.getElementById('heart-display');
const hintEl = document.getElementById('lottery-hint');
const messageEl = document.getElementById('message');
const fpDisplay = document.getElementById('fingerprint-display');
const resultBanner = document.getElementById('result-banner');
const resultTitle = document.getElementById('result-title');
const resultCode = document.getElementById('result-code');
const resultPrize = document.getElementById('result-prize');
const progressBarWrap = document.getElementById('progress-bar-wrap');
const progressBar = document.getElementById('progress-bar');

// 點擊漣漪效果
const rippleEmojis = ['💕', '💗', '💖', '✨', '💛', '🤍', '💘'];
function spawnRipple(x, y) {
    const el = document.createElement('div');
    el.className = 'click-ripple';
    el.textContent = rippleEmojis[Math.floor(Math.random() * rippleEmojis.length)];
    el.style.left = (x - 12) + 'px';
    el.style.top = (y - 12) + 'px';
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 1000);
}

// 手機震動回饋
function vibrate(ms) {
    if (navigator.vibrate) navigator.vibrate(ms);
}

// 初始化 fingerprint + device signals
fpScript.onload = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    myFingerprint = result.visitorId;

    const signals = collectDeviceSignals();
    // 把硬體特徵組成一個字串，由後端 hash 成 device fingerprint
    myDeviceId = [
        signals.screen, signals.dpr, signals.cores,
        signals.memory, signals.platform, signals.gpu,
        signals.touchPoints,
    ].join('|');

    console.log('Browser FP:', myFingerprint);
    console.log('Device signals:', myDeviceId);

    restoreResult();
    checkLottery();
};

// 點擊愛心 = 增加填充進度
let lastClickTime = 0;

const encourageMessages = [
    '繼續點擊，傳遞你的祝福！',
    '每一下都是滿滿的心意 💕',
    '讓愛心感受你的溫暖！',
    '祝福正在累積中...',
    '快了！再多一點點心意！',
    '你的祝福好溫暖 ✨',
];

heartDisplay.addEventListener('click', (e) => {
    if (!myFingerprint) return;
    if (registered) return;
    if (!currentLottery || currentLottery.status !== 'open') return;

    lastClickTime = Date.now();
    clickCount++;

    const progress = Math.min(clickCount / CLICKS_TO_FILL, 1);
    window.heartFillLevel = progress;

    // 視覺回饋
    if (window.heartBeat) window.heartBeat();
    spawnRipple(e.clientX || window.innerWidth / 2, e.clientY || window.innerHeight / 2);
    vibrate(30);

    // 進度條
    progressBarWrap.classList.add('show');
    progressBar.style.width = (progress * 100) + '%';

    // 提示文字 — 隨進度變化
    const percent = Math.round(progress * 100);
    if (progress < 1) {
        const msgIdx = Math.min(Math.floor(progress * encourageMessages.length), encourageMessages.length - 1);
        hintEl.textContent = `${percent}% — ${encourageMessages[msgIdx]}`;
    }

    // 填滿了！
    if (progress >= 1 && !fillAnimating) {
        fillAnimating = true;
        vibrate([50, 30, 50, 30, 100]); // 完成時長震動
        if (window.heartFillComplete) window.heartFillComplete();
        hintEl.textContent = '💖 滿滿的祝福！傳送中...';
        progressBar.style.width = '100%';
        registerLottery();
    }
});

async function registerLottery() {
    try {
        const res = await fetch('/api/lottery/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ fingerprint: myFingerprint, deviceId: myDeviceId }),
        });
        const data = await res.json();

        if (data.success) {
            registered = true;
            myDisplayCode = data.displayCode;
            showMessage(data.message);
            fpDisplay.style.display = 'block';
            fpDisplay.textContent = `您的祝福編號：${myDisplayCode}`;
            hintEl.textContent = '✅ 祝福已送達，敬請期待驚喜...';
            progressBarWrap.classList.remove('show');
        } else {
            showMessage(data.error || '祝福傳送失敗，再試一次吧');
            fillAnimating = false;
        }
    } catch (err) {
        showMessage('連線不太順，再試一次吧');
        fillAnimating = false;
    }
}

function showMessage(text) {
    messageEl.textContent = text;
    messageEl.classList.add('show');
    setTimeout(() => messageEl.classList.remove('show'), 3000);
}

// 填充進度隨時間緩慢下降（放慢速度，對老人家友善）
setInterval(() => {
    if (registered || !currentLottery || currentLottery.status !== 'open') return;
    if (clickCount <= 0) return;

    // 2 秒沒點擊就開始消退
    if (Date.now() - lastClickTime > 2000) {
        clickCount = Math.max(0, clickCount - 0.35);
        window.heartFillLevel = Math.min(clickCount / CLICKS_TO_FILL, 1);
        progressBar.style.width = (window.heartFillLevel * 100) + '%';

        if (clickCount > 0 && !fillAnimating) {
            const percent = Math.round(window.heartFillLevel * 100);
            hintEl.textContent = `${percent}% — 再點一下，別讓祝福溜走 💕`;
        } else if (clickCount <= 0) {
            progressBarWrap.classList.remove('show');
        }
    }
}, 200);

// 從 localStorage 恢復已開獎的結果
function restoreResult() {
    const saved = localStorage.getItem('lottery_result');
    if (!saved) return false;

    const result = JSON.parse(saved);
    myDisplayCode = result.myCode;
    registered = true;
    resultShown = true;
    window.heartFillLevel = 1;
    fpDisplay.style.display = 'block';
    fpDisplay.textContent = `您的祝福編號：${myDisplayCode}`;

    showResultBanner(result.isWinner, result.myCode, false);
    return true;
}

// 輪詢抽獎狀態
async function checkLottery() {
    try {
        const fpParam = myFingerprint ? `?fp=${myFingerprint}&did=${encodeURIComponent(myDeviceId || '')}` : '';
        const res = await fetch(`/api/lottery/active${fpParam}`);
        const data = await res.json();
        currentLottery = data.lottery;

        if (data.myCode && !registered) {
            registered = true;
            myDisplayCode = data.myCode;
            window.heartFillLevel = 1;
            fpDisplay.style.display = 'block';
            fpDisplay.textContent = `您的祝福編號：${myDisplayCode}`;
        }

        // 檢查是否需要重置狀態（抽獎被刪除、或換了新抽獎）
        const savedResult = localStorage.getItem('lottery_result');
        const needsReset =
            // 抽獎被刪除了，但本地還有舊結果
            (!currentLottery && savedResult) ||
            // 換了新的 open 抽獎
            (currentLottery && currentLottery.status === 'open' && savedResult &&
                JSON.parse(savedResult).lotteryId !== currentLottery.id);

        if (needsReset) {
            localStorage.removeItem('lottery_result');
            resultShown = false;
            registered = false;
            myDisplayCode = null;
            clickCount = 0;
            fillAnimating = false;
            window.heartFillLevel = 0;
            fpDisplay.style.display = 'none';
            resultBanner.className = 'result-banner';
            progressBarWrap.classList.remove('show');
            progressBar.style.width = '0%';
            if (window.heartReset) window.heartReset();
        }

        if (!currentLottery) {
            hintEl.textContent = '';
        } else if (currentLottery.status === 'open') {

            if (!registered) {
                hintEl.textContent = `💕 點擊愛心，送出你的祝福`;
            } else {
                hintEl.textContent = '✅ 祝福已送達，敬請期待驚喜...';
            }
        } else if (currentLottery.status === 'drawn') {
            if (!resultShown) {
                handleDrawResult(currentLottery);
            }
        }
    } catch (err) {
        console.error('Error checking lottery:', err);
    }

    setTimeout(checkLottery, 3000);
}

function handleDrawResult(lottery) {
    if (!myFingerprint || !registered) {
        hintEl.textContent = '本輪驚喜已揭曉';
        return;
    }

    resultShown = true;
    const isWinner = lottery.winners && myDisplayCode && lottery.winners.includes(myDisplayCode);

    localStorage.setItem('lottery_result', JSON.stringify({
        lotteryId: lottery.id,
        myCode: myDisplayCode,
        isWinner,
    }));

    setTimeout(() => {
        showResultBanner(isWinner, myDisplayCode, true);
    }, 1500);
}

function showResultBanner(isWinner, code, withEffects) {
    resultBanner.className = 'result-banner show ' + (isWinner ? 'winner' : 'loser');

    if (isWinner) {
        resultTitle.textContent = '🎉 恭喜！你的祝福被選中了！🎉';
        resultCode.textContent = `祝福編號 #${code}`;
        resultPrize.textContent = '';
        if (window.heartGold) window.heartGold();
        if (withEffects) spawnConfetti();
    } else {
        resultTitle.textContent = '感謝你的祝福 💕';
        resultCode.textContent = `祝福編號 #${code}`;
        resultPrize.textContent = '每一份心意都是最好的禮物';
    }
}

function spawnConfetti() {
    const colors = ['#ffd700', '#ff6b6b', '#ff69b4', '#87ceeb', '#98fb98', '#dda0dd'];
    for (let i = 0; i < 80; i++) {
        const el = document.createElement('div');
        el.classList.add('confetti');
        el.style.left = Math.random() * 100 + 'vw';
        el.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        el.style.animationDelay = Math.random() * 2 + 's';
        el.style.width = Math.random() * 8 + 5 + 'px';
        el.style.height = Math.random() * 8 + 5 + 'px';
        el.style.borderRadius = Math.random() > 0.5 ? '50%' : '0';
        document.body.appendChild(el);
        setTimeout(() => el.remove(), 5000);
    }
}

}); // end DOMContentLoaded
